import { onAuthStateChanged } from "firebase/auth"

import { auth } from "./auth"

import type {
  User as FirebaseUser,
  UserInfo as FirebaseUserInfo,
} from "firebase/auth"

export type CurrentUserType = FirebaseUser | null

export type User = FirebaseUser
export type UserInfo = FirebaseUserInfo
export type PromiseCurrentUserType = Promise<CurrentUserType>

export const initFirebaseAuth = (): PromiseCurrentUserType => {
  return new Promise((resolve) => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      resolve(user)
      unsubscribe()
    })
  })
}
